import { extend } from 'underscore';
import { getBlockerStyle } from './shared-styles-from-theme-fluent';

const selector = ({ palette }) => ({
  width: 300,
  '& .selector-v2': {
    '& .table.table--fixed-layout': {
      tableLayout: 'fixed',
    },
    '& .selector__data-progress-backdrop': {
      backgroundColor: 'white',
      bottom: 0,
      left: 0,
      opacity: 0.8,
      position: 'absolute',
      right: 0,
      top: 0,
    },
    '& .selector__data-progress-overlay': {
      backgroundColor: 'white',
      height: 40,
      left: '50%',
      lineHeight: '40px',
      marginLeft: '-60px',
      marginTop: '-20px',
      overflowX: 'hidden',
      overflowY: 'hidden',
      position: 'absolute',
      textAlign: 'center',
      textOverflow: 'ellipsis',
      top: '50%',
      width: 120,
      whiteSpace: 'pre',
      '& .progress__icon': extend({
        display: 'inline-block',
        backgroundRepeat: 'no-repeat',
      }, getBlockerStyle(30, palette)),
      '& span': {
        verticalAlign: 'middle',
      },
    },
  },
  '& .selector-v2 .selector__data': {
    maxHeight: '360px',
    overflowY: 'auto',
    position: 'relative',
  },
  '& .search-box-v2': {
    height: 48,
    '& .search-box__input-group': {
      paddingBottom: 5,
      borderBottom: `1px solid ${palette.neutralPrimary}`,
      '&:active, &:focus, &:hover': {
        borderBottom: `1px solid ${palette.themePrimary}`,
      },
    },
    '& .search-box__icon.iconba.iconba-Search': {
      marginRight: 16,
      paddingLeft: 16,
      paddingTop: 12,
      paddingBottom: 16,
      display: 'inline-block',
      float: 'left',
    },
    '& .search-box__input.form-control': {
      paddingTop: 16,
      marginLeft: '0px !important',
      width: 'auto !important',
      display: 'inline-block',
      border: '0',
    },
  },
  '& .column-tri-state-checkbox': {
    lineHeight: '11px',
    '& span': {
      width: 20,
      height: 20,
      border: `1px solid ${palette.neutralPrimary}`,
      boxSizing: 'border-box',
      borderRadius: 2,
      display: 'inline-block',
    },
    '& .glyphicon': {
      position: 'initial !important',
      padding: '1px 0 0 0',
      margin: '0 !important',
      fontFamily: 'MsAds MDL2 Assets !important',
    },
    '& .glyphicon.glyphicon-ok': {
      backgroundColor: palette.themePrimary,
    },
    '& .glyphicon.glyphicon-ok:before': {
      paddingLeft: '1px',
      fontSize: 16,
      lineHeight: '16px',
      content: '"\\E73E" !important',
      color: 'white',
    },
    '& .glyphicon.glyphicon-minus': {
      color: palette.themePrimary,
      border: `1px solid ${palette.neutralDark} !important`,
    },
    '& .glyphicon.glyphicon-minus:before': {
      content: '"\\E73C" !important',
      paddingLeft: '1px',
      fontSize: 16,
      lineHeight: '16px',
      color: palette.themePrimary,
    },
  },
  '& .table__cell--menu-item-style.table__cell--icon': {
    width: 36,
    height: 36,
    border: 'none',
  },
  '& .table__cell--menu-item-style.table__cell--ellipsis-overflow': {
    height: '36px !important',
    paddingLeft: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: '14px !important',
    border: 'none',
  },
  '& li.action': {
    height: 36,
    '& a': {
      padding: '0px 10px',
      lineHeight: '36px',
      fontSize: 14,
      color: `${palette.neutralPrimary} !important`,
      display: 'block',
    },
    '&:hover': {
      backgroundColor: palette.neutralLighter,
      color: palette.neutralDark,
    },
  },
  '& .divider': {
    background: palette.neutralTertiaryAlt,
    display: 'block',
  },
  '& .table': {
    marginBottom: '0',
  },
});

export const predicateValueEditorStyle = {
  selector,
};
